export const MINIAPP_FID = 384019;
